/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable react/no-children-prop */
import React, { useEffect } from 'react';
import { Container } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';

const SelectedShopShare: React.FC = () => {
  const { idRestaurante, promotionShop }: any = useParams();
  const navigate = useNavigate();

  const handleToPage = (url: string): any => {
    return navigate(url, { replace: true });
  };
  useEffect(() => {
    localStorage.setItem('@mais/delivery/access_shop', 'access_shop');
    if (idRestaurante && !promotionShop) {
      handleToPage(
        `/shop/detail/list/product/subcategorie/${window.btoa(idRestaurante)}`,
      );
      return;
    }
    if (idRestaurante && promotionShop) {
      handleToPage(`/promotionsshop/${idRestaurante}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idRestaurante]);

  return <Container />;
};

export default SelectedShopShare;
